<template>
    <div class="x-selection">
        <el-select  :style="config.selectType == SelectType.MULTIPLE_SELECT ? 'width:100%' : ''"
            :model-value="sValue"
            :multiple="config.selectType != SelectType.SINGLE_SELECT" :placeholder="config.placeholder"
            allow-create popper-class="no-popper" :reserve-keyword="false" :suffix-icon="Search"
            :disabled="readonly"
            @remove-tag="removeTagHandler"
            @visible-change="(visible)=> {if (visible) openDialogHandler()}"
            :clearable="true"
            @clear="clearHandler"
        >
            <el-option  v-for="(option, index) in dataOptions" :label="option.label" :value="option.value + ''" :key="index">
                {{option.label}}
            </el-option>
        </el-select>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import { Search } from '@element-plus/icons-vue';
import XSelectionDialog from '../../dialog/XSelectionDialog.vue';
import SelectType from '../data/SelectType';
import { openDialog } from '../../dialog/XDialog';
import { getDynamicOptions } from '../utils.js';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})

defineEmits({
    'update:modelValue': null,
})

const sValue = ref(null);
const dataOptions = ref([]);
const getModelValue = (modelValue)=> {
    if (props.config?.selectType != SelectType.SINGLE_SELECT) {
        if (modelValue == null) return [];
        const res = [];
        for (const value of modelValue) {
            res.push(value + '')
        }
        return res;
    } else {
        if (modelValue == null) return null;
        return modelValue + '';
    }
}
watch(()=>props.config?.dataOptions, async (value)=> {
    // console.log(value, props.modelValue);
    if (!props.config?.dataOptions) return;
    if (!props.modelValue) {
        dataOptions.value = [];
        sValue.value = null;
        return;
    }
    let keys = getModelValue(props.modelValue);
    if (!keys) return;
    if (!(keys instanceof Array)) keys = [keys];
    const datas = await props.config?.dataOptions.dataInfo.getByKeys(keys, props.config?.dataOptions.keyField);
    dataOptions.value = getDynamicOptions(props.config?.dataOptions, props.config.filter, props.data, datas);
    if (props.config.selectType == SelectType.SINGLE_SELECT && keys.length) keys = keys[0]
    sValue.value = keys;
})
watch(()=> props.modelValue, async (value)=> {
    if (!props.config?.dataOptions) return;
    if (!value) {
        dataOptions.value = [];
        sValue.value = null;
        return;
    }
    let keys = getModelValue(value);
    if (!keys) return;
    if (!(keys instanceof Array)) keys = [keys];
    const datas = await props.config?.dataOptions.dataInfo.getByKeys(keys, props.config?.dataOptions.keyField);
    dataOptions.value = getDynamicOptions(props.config?.dataOptions, props.config.filter, props.data, datas);
    if (props.config.selectType == SelectType.SINGLE_SELECT && keys.length) keys = keys[0]
    sValue.value = keys;
}, {immediate:true})

const findOption = (options, value)=> {
    for (const option of options) {
        if (option.value == value) return option;
    }
    return null;
}

const getSelected = (value, options)=> {
    if (!options) return null;
    if (props.config?.selectType != SelectType.SINGLE_SELECT) {
        const selected = [];
        if (value) {
            for (const v of value) {
                selected.push(findOption(options, v));
            }
        }
        return selected;
    } else {
        if (!value) return null;
        const selected = findOption(options, value);
        return selected ? selected.label : null;
    }
}

const mergeOptions = (targetOptions, options)=> {
    if (!options || !options.length) return [];
    for (const option of options) {
        if (!findOption(targetOptions, option.value)) targetOptions.push(option);
    }
    return targetOptions.slice();
}

const openDialogHandler = async ()=> {
    const dialogInfo = await openDialog({selectType:props.config?.selectType, selected:props.modelValue, dataOptions:props.config?.dataOptions || [], query:props.config?.query, config:props.config?.config}, XSelectionDialog, props.data);
    if (!dialogInfo) return;
    const selected = dialogInfo['data'];
    if (props.config?.map && props.data && selected) {
        const data = props.data;
        if (props.config?.selectType != SelectType.SINGLE_SELECT) {
            for (const [mapField, field] of Object.entries(props.config?.map)) {
                const v = [];
                for (const d of selected) {
                    v.push(d[field]);
                }
                data[mapField] = v;
            }
            
        } else {
            for (const [mapField, field] of Object.entries(props.config?.map)) {
                data[mapField] = selected[field];
            }
        }
    }
    // if (!props.config?.dataOptions) props.config.dataOptions = [];

    // props.config.dataOptions = mergeOptions(props.config?.dataOptions || [], dialogInfo['options']);
    // dataOptions.value = props.config.dataOptions;
    // const opts = getDynamicOptions(dialogInfo['options'], props.config?.filter, props.data, dialogInfo['data']);
    // dataOptions.value = mergeOptions(dataOptions.value, opts);
    inst.emit('update:modelValue', dialogInfo['selected']);
}

// const selected = ref(null);
const removeTagHandler = (data)=> {
    const values = [...getModelValue(props.modelValue)];
    const index = values.indexOf(data);
    values.splice(index, 1);
    if (props.config?.map && props.data) {
        for (const [mapField, field] of Object.entries(props.config.map)) {
            if (props.data[mapField]) {
                try {
                    props.data[mapField].splice(index, 1);
                } catch(e) {}
            }
        }
    }
    inst.emit('update:modelValue', values);
}
const clearHandler = ()=> {
    if (props.config?.map && props.data) {
        for (const [mapField, field] of Object.entries(props.config.map)) {
            try {
                props.data[mapField] = null;
            } catch(e) {}
        }
    }
    inst.emit('update:modelValue', null);
}
</script>
<style scoped>
::v-deep .el-select__icon {
    transform: rotateZ(0) !important;
}
.x-selection {
    width: 100%;
}
</style>
<style>
.no-popper {
    display: none !important;
}
</style>